


























import { mapState } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  computed: mapState(['currentPage', 'isMobole', 'seriesType']),
})
export default class Label extends Vue {
  isMobole!: Boolean;
  seriesType!: Boolean;
  type = false;
  menu1 = [
    {
      name: '隔热隔晒',
      page: 'Insulation',
    },
    {
      name: '清晰防眩光',
      page: 'Dazzle',
    },
    {
      name: '信号无干扰',
      page: 'Signal',
    },
    {
      name: '绿色环保材质',
      page: 'Environment',
    },
    {
      name: '超长质保',
      page: 'Warranty',
    },
  ];
  menu2 = [
    {
      name: '精选系列',
      page: 'Selected',
    },
    {
      name: '尊享系列',
      page: 'Enjoy',
    },
    {
      name: '安全尊享系列',
      page: 'EnjoySafety',
    },
    {
      name: '全车安全系列',
      page: 'VehicleSafety',
    },
  ];

  item = {
    icon: '',
    title: '',
    txt: '',
  };

  mounted() {}
  onType() {
    this.type = !this.type;
  }
  pageRouter(i) {
    this.$store.commit('setSeriesType', i);
  }
  pageRouter2(i) {
    this.$store.commit('setCurrentPage', i);
  }
}
